import React, { useState, useEffect } from "react";
import "./styles.css";

/**
 * @function UIToggle
 * @param {STRING} className - Additional classes to add to the UIToggle.
 * @param {FUNCTION} onChange - Allows us to listen for an interaction with the input.
 * @param {dataPoint} dataPoint - data-point to add to wrapper for captures. 
 * @return {React.Component}
 * @exported true
 * @description This is a true/false toggle.
 * @example
 * <UIToggle className="added-style" />
 */
export default function UIToggle(props) {
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  const [getToggle, setToggle] = useState(props.checked ?? false);
  const onChange = () => {
    if (props.disabledPrompt !== true) {
      if (props.onChange instanceof Function) {
        props.onChange(!getToggle);
      }
      setToggle(!getToggle);
    }
  }
  useEffect(() => setToggle(props.checked ?? false), [props.checked]);
  
  return (
    <div className={className + " ui-toggle"} {...dataPoint}>
      <label className="toggle-switch">
        <input className="toggle-checkbox" type="checkbox" checked={getToggle} onChange={onChange} />
        <div className="toggle-background"></div>
        <div className="toggle-switch-indicator"></div>
      </label>
    </div>
  );
}